import React, { useState } from "react";
import { loginUser, useAuthState, useAuthDispatch } from '../../Context';
import { Button, ButtonGroup,  FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText, Input} from '@chakra-ui/react'

function Login(props){
    const [regEmail, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useAuthDispatch();
    const { loading, errorMessage } = useAuthState();
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            let response = await loginUser(dispatch, { "email": regEmail, "password": password });
            if (!response.token) return;
            props.history.push('/');
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="submit-form">
            <div className={{ width: 200 }}>
                <h1>Login Page</h1>
                <FormControl>
                            <FormLabel htmlFor='email'>Email</FormLabel>
                            <Input
                                type='text'
                                id='regemail'
                                value={regEmail}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={loading}
                            />
                            <FormLabel htmlFor='password'>Password</FormLabel>
                            <Input
                                type='password'
                                id='password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={loading}
                            />
                    <Button colorScheme='blue' onClick={handleLogin} disabled={loading}>Login</Button>
                    </FormControl>
            </div>
        </div>
    );
}


export default Login;
